<template lang="html">
  <div class="instant_price">
    <div class="dynamic-component-keep-alive-demo clearfix">
      <div class="button-group p-0">
        <div class="row align-items-center">
          <button
            class="__buttonStep col p-0"
            v-for="step in steps"
            v-bind:key="step.id"
            v-bind:class="{'__selectedstep': step.status === true}"
            v-on:click="selectedSteps(step.id)"
          >
            <p>
              {{ step.title }}
            </p>
            <p class="__subtitle text-capitalize">
              {{ step.subtitle }}
            </p>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid ">
      <div class="row align-items-center">
        <div class="_button__prev">
          <button
            v-if="!isHidden"
            class="__buttonPev"
            @click.prevent="ButtonPrev()"
          >
            <img src = "@/assets/image/white-right-arrow@3x.png">
          </button>
        </div>
        <div class="col">
          <keep-alive>
            <component
              v-bind:is="CurrentStepComponent"
              @IntantPriceFreightMode="chkFreightMode"
              @IntantPriceShipmentType="chkShipmentType"
              @IntantPriceProductType="chkProductType"
              @IntantPriceDestination="chkDestination"
              @IntantPriceShipmentDate="chkShipmentDate"
              @IntantPriceData="inputData"
              @errorInput="errorInput"
              :inputData="data"
              :showError="showError"
              :showErrorProductType="showErrorProductType"
              :showErrorDestination="showErrorDestination"
              :checkErrorStat="checkErrorStat"
            >
            </component>
          </keep-alive>
        </div>
        <div class="_button__next">
          <b-button
            v-if="!isHidden"
            class="__buttonNext"
            @click.prevent="ButtonNext()"
          >
            Next
          </b-button>
        </div>
      </div>
    </div>
    <!-- modals  https://bootstrap-vue.js.org/docs/components/modal/ -->
  </div>
</template>
<script>
import FreightMode from '@/components/instantPrice/FreightMode'
import ShipmentAir from '@/components/instantPrice/ShipmentAir'
import ShipmentOcean from '@/components/instantPrice/ShipmentOcean'
import ProductType from '@/components/instantPrice/ProductType'
import Destination from '@/components/instantPrice/Destination'
import ShipmentDate from '@/components/instantPrice/ShipmentDate'
import Booking from '@/components/instantPrice/Booking'

export default {
  name: 'instantPrice',
  components: {
    FreightMode,
    ShipmentAir,
    ShipmentOcean,
    ProductType,
    Destination,
    ShipmentDate,
    Booking
  },
  data () {
    return {
      data: {
        shipmentLoad: '',
        form: {}
      },
      form: {
        originArea: 'fob',
        destinationArea: 'fob',
        goodsValueCurrency: 'IDR',
        loadsAIRCargo: [],
        loadsAIRCourier: [],
        datePickup: '',
        insurance: '',
        goodsValue: '',
        dangerousGoods: '',
        custom: '',
        shipmentType: '',
        commoditiesClass: '',
        valueOfGoods: 0,
        originCountry: '',
        originCity: '',
        destinationCountry: '',
        destinationCity: ''
      },
      selectedtabs: FreightMode,
      selectedstep: 1,
      showModal1: false,
      isHidden: false,
      status1: false,
      steps: [
        {
          id: 1,
          title: 'Freight Mode',
          subtitle: 'Choose your freight mode',
          content: FreightMode,
          status: true
        },
        {
          id: 2,
          title: 'Shipment Type',
          subtitle: 'Choose your shipment type',
          content: ShipmentOcean,
          status: false
        },
        {
          id: 3,
          title: 'Product Type',
          subtitle: 'Choose your product type',
          content: ProductType,
          status: false
        },
        {
          id: 4,
          title: 'Route',
          subtitle: 'Choose your destination',
          content: Destination,
          status: false
        },
        {
          id: 5,
          title: 'Shipment Date',
          subtitle: 'Choose your shipment date',
          content: ShipmentDate,
          status: false
        }
      ],
      showError: false,
      showErrorProductType: false,
      showErrorDestination: false,
      errorData: {},
      checkErrorStat: 'check',
      payloadLog: {
        featureName: 'CREATE INSTANT PRICE',
        featureStep: 1,
        stepName: 'Freight Mode',
        featureProcess: {
          status: 'success',
          data: {}
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    CurrentStepComponent: function () {
      const _this = this
      if (this.selectedtabs === FreightMode) {
        _this.selectedstep = 1
        _this.steps[0].status = true
        _this.isHidden = false
        switch (this.steps[0].subtitle) {
          case 'Air':
            _this.steps[0].subtitle = 'Air'
            break
          case 'Ocean':
            _this.steps[0].subtitle = 'Ocean'
            break
          default:
            _this.steps[0].subtitle = 'Air'
            break
        }
      }
      if (this.selectedtabs === ShipmentOcean || this.selectedtabs === ShipmentAir) {
        _this.steps[1].content = (this.steps[0].subtitle === 'Air') ? ShipmentAir : ShipmentOcean
        _this.selectedstep = 2
        _this.steps[1].status = true
        _this.isHidden = false
      }
      if (this.selectedtabs === ProductType) {
        _this.selectedstep = 3
        _this.steps[2].status = true
        _this.isHidden = false
      }
      if (this.selectedtabs === Destination) {
        _this.selectedstep = 4
        _this.steps[3].status = true
        _this.isHidden = false
      }
      if (this.selectedtabs === ShipmentDate) {
        _this.selectedstep = 5
        _this.steps[4].status = true
      }
      return this.selectedtabs
    }
  },
  methods: {
    init () {
      // insert log
      this.payloadLog.featureProcess.data = this.form
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    chkFreightMode (data) {
      this.steps[0].subtitle = data
    },
    chkShipmentType (data) {
      this.steps[1].subtitle = data
    },
    chkProductType (data) {
      this.steps[2].subtitle = data
    },
    chkDestination (data) {
      this.steps[3].subtitle = data
    },
    chkShipmentDate (data) {
      this.steps[4].subtitle = data
    },
    inputData (payload) {
      if (payload.typeObj && payload.typeObj === 'sub') {
        Object.assign(this.form, payload)
      } else {
        Object.assign(this.data, payload)
      }
    },
    errorInput (payload) {
      Object.assign(this.errorData, payload)
    },
    ButtonNext: function () {
      let _this = this
      let temp
      const data = this.form
      if (this.selectedtabs === FreightMode) {
        switch (this.steps[0].subtitle) {
          case 'Air':
            this.steps[0].subtitle = 'Air'
            break
          case 'Ocean':
            this.steps[0].subtitle = 'Ocean'
            break
          default:
            this.steps[0].subtitle = 'Air'
            break
        }
        temp = _this.steps[0].subtitle === 'Air' ? ShipmentAir : ShipmentOcean
        this.selectedtabs = temp

        // insert log
        _this.payloadLog.featureStep = 2
        _this.payloadLog.stepName = 'Shipment Type'
        _this.payloadLog.featureProcess.data = _this.form
        this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
      } else if (this.selectedtabs === ShipmentOcean || this.selectedtabs === ShipmentAir) {
        if (this.selectedtabs === ShipmentAir) {
          if (data.shipmentType === 'AIRCARGO') {
            if (this.errorData.errorsCargo) {
              this.showError = true
              _this.checkErrorStat = 'check1'
            } else {
              _this.selectedtabs = ProductType
              _this.checkErrorStat = 'false'
            }
          } else if (data.shipmentType === 'AIRCOURIER') {
            if (this.errorData.errorsCourier) {
              this.showError = true
              _this.checkErrorStat = 'check1'
            } else {
              _this.selectedtabs = ProductType
              _this.checkErrorStat = 'false'
            }
          }
        } else {
          if (data.shipmentType === 'SEALCL') {
            if (this.errorData.errorsLCL) {
              this.showError = true
              _this.checkErrorStat = 'check1'
            } else {
              _this.selectedtabs = ProductType
              _this.checkErrorStat = 'false'
            }
          } else {
            if (this.errorData.errorsFCL) {
              this.showError = true
              _this.checkErrorStat = 'check1'
            } else {
              _this.selectedtabs = ProductType
              _this.checkErrorStat = 'false'
            }
          }
        }
        // insert log
        _this.payloadLog.featureStep = 3
        _this.payloadLog.stepName = 'Product Type'
        _this.payloadLog.featureProcess.data = _this.form
        this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
      } else if (this.selectedtabs === ProductType) {
        if ((data.commoditiesClass !== 'DG' && data.productType && data.goodsValue && data.commoditiesHSCode && data.commoditiesProduct) ||
        (data.commoditiesClass === 'DG' && data.productType && data.goodsValue && data.commoditiesHSCode && data.commoditiesProduct && data.un_number)
        ) {
          _this.selectedtabs = Destination
          _this.checkErrorStat = 'false'
        } else {
          this.showErrorProductType = true
          _this.checkErrorStat = 'checkProductType'
        }
        // insert log
        _this.payloadLog.featureStep = 4
        _this.payloadLog.stepName = 'Route'
        _this.payloadLog.featureProcess.data = _this.form
        this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
      } else if (this.selectedtabs === Destination) {
        if ((data.originCountry && data.originCity && data.destinationCountry && data.destinationCity && data.optiontp === 'ptp') ||
         (data.originCountry && data.originCity && data.destinationCountry && data.destinationCity && data.optiontp === 'dtp' && data.pickup_address) ||
         (data.originCountry && data.originCity && data.destinationCountry && data.destinationCity && data.optiontp === 'ptd' && data.delivery_address) ||
         (data.originCountry && data.originCity && data.destinationCountry && data.destinationCity && data.optiontp === 'dtd' && data.delivery_address && data.pickup_address)
        ) {
          _this.selectedtabs = ShipmentDate
        } else {
          this.showErrorDestination = true
        }
        // insert log
        _this.payloadLog.featureStep = 5
        _this.payloadLog.stepName = 'Shipment Date'
        _this.payloadLog.featureProcess.data = _this.form
        this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
      } else if (this.selectedtabs === ShipmentDate) {
        if (data.datePickup) {
          // _this.$eventHub.$emit('dialog-instantprice')
          _this.isHidden = true
          _this.selectedtabs = Booking
          this.data.form = this.form
          this.$store.dispatch('instantprice/POST_INSTANT_PRICE', this.data)
        } else {
          this.showError = true
        }
      }
      return this.selectedtabs
    },
    ButtonPrev: function () {
      const _this = this
      var i
      if (this.selectedtabs === ShipmentDate) {
        _this.selectedtabs = Destination
        for (i = 4; i < _this.steps.length; i++) {
          _this.steps[i].status = false
        }
      } else if (this.selectedtabs === Destination) {
        _this.selectedtabs = ProductType
        _this.steps[3].status = false
        for (i = 3; i < _this.steps.length; i++) {
          _this.steps[i].status = false
        }
      } else if (this.selectedtabs === ProductType) {
        _this.selectedtabs = _this.steps[0].subtitle === 'Air' ? ShipmentAir : ShipmentOcean
        for (i = 2; i < _this.steps.length; i++) {
          _this.steps[i].status = false
        }
      } else if (this.selectedtabs === ShipmentOcean || this.selectedtabs === ShipmentAir) {
        _this.selectedtabs = FreightMode
        for (i = 1; i < _this.steps.length; i++) {
          _this.steps[i].status = false
        }
      } else if (this.selectedtabs === FreightMode) {
        _this.$eventHub.$emit('dialog-request-leave')
      }
      return this.selectedtabs
    },
    selectedSteps: function (id) {
      const _this = this
      if (_this.steps[id - 1].status === true) {
        _this.selectedtabs = _this.steps[id - 1].content
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/instantPrice/index.vue